import { fork, takeEvery } from 'redux-saga/effects';

import {
  ChangeExtractRefreshSchedule, ChangeRemoteExtractRefresh, ChangeRemoteExtractRefreshExpectedDuration,
  CreateExtractRefresh, CreateExtracts, CreateRemoteExtractRefresh,
  DeleteExtractRefresh, DeleteRemoteExtractRefresh,
  ResumeExtractRefresh, RunExtractRefresh,
RunExtractRefreshNow,
  SetExtractRefreshPriority} from '../../../bootstrap/redux/actions/AppActionTypes';
import { handleChangeRemoteExtractRefreshExpectedDurationAction } from '../remoteExtractRefresh/ChangeRemoteExtractRefreshExpectedDurationSaga';
import { handleChangeRemoteExtractRefreshAction } from '../remoteExtractRefresh/ChangeRemoteExtractRefreshSaga';
import { handleCreateRemoteExtractRefreshAction } from '../remoteExtractRefresh/CreateRemoteExtractRefreshSaga';
import { handleDeleteRemoteExtractRefreshAction } from '../remoteExtractRefresh/DeleteRemoteExtractRefreshSaga';
import { handleChangeExtractRefreshScheduleAction } from './ChangeExtractRefreshScheduleSaga';
import { handleCreateExtractRefreshAction } from './CreateExtractRefreshSaga';
import { handleDeleteExtractRefreshAction } from './DeleteExtractRefreshSaga';
import { watchExtractFailureNotificationActions } from './ExtractFailureNotificationSaga';
import { handleResumeExtractRefreshAction } from './ResumeExtractRefreshSaga';
import { handleCreateExtractsAction } from './RunCreateExtractsSaga';
import { handleRunExtractRefreshNowAction } from './RunExtractRefreshNowSaga';
import { handleRunExtractRefreshAction } from './RunExtractRefreshSaga';
import { handleSetExtractRefreshPriorityAction } from './SetExtractRefreshPrioritySaga';


export function* rootExtractRefreshSaga() {
  yield takeEvery(CreateExtractRefresh, handleCreateExtractRefreshAction);
  yield takeEvery(CreateExtracts, handleCreateExtractsAction);
  yield takeEvery(RunExtractRefresh, handleRunExtractRefreshAction);
  yield takeEvery(RunExtractRefreshNow, handleRunExtractRefreshNowAction);
  yield takeEvery(ResumeExtractRefresh, handleResumeExtractRefreshAction);
  yield takeEvery(ChangeExtractRefreshSchedule, handleChangeExtractRefreshScheduleAction);
  yield takeEvery(SetExtractRefreshPriority, handleSetExtractRefreshPriorityAction);
  yield takeEvery(DeleteExtractRefresh, handleDeleteExtractRefreshAction);
  yield takeEvery(CreateRemoteExtractRefresh, handleCreateRemoteExtractRefreshAction);
  yield takeEvery(DeleteRemoteExtractRefresh, handleDeleteRemoteExtractRefreshAction);
  yield takeEvery(ChangeRemoteExtractRefresh, handleChangeRemoteExtractRefreshAction);
  yield takeEvery(ChangeRemoteExtractRefreshExpectedDuration, handleChangeRemoteExtractRefreshExpectedDurationAction);
  yield fork(watchExtractFailureNotificationActions);
}
